module.exports = __webpack_public_path__ + "img/wayError@2x.1a8fd0cf.png";